import logo from './logo.svg';
import './App.css';
import React from "react";
import ApiCtrl from "./svc/ApiCtrl";
import 'mapbox-gl/dist/mapbox-gl.css';
import Map, {Layer, Popup, Source} from 'react-map-gl';
import {
    Checkbox,
    Typography,
    Box,
    CircularProgress,
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails, IconButton, Card, CardMedia, CardActions, CardContent, CardHeader
} from "@mui/material";
import * as turf from "@turf/turf";
import PdfIcon from '@mui/icons-material/PictureAsPdf';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import {Margin, usePDF} from "react-to-pdf";

// eslint-disable-next-line
import mapboxgl from '!mapbox-gl';
import PageIris from "./view/PageIris";
import PageCommune from "./view/PageCommune";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';

export const blackColor = "black";
export const paperColor = "white";
export const mainColor = "#d62a8e";
export const secondColor = "#3222a5";
export const thirdColor = "#E6F4FF";
export const disabledColor = "#8a8b8e";


export const artiHabitat = "#5FD1F1"
export const artiMixte = "#597FA5"
export const artiInconnue = "#063C4B"
export const artiActive = "#4225AB"

export const artiRou = "#0b0421"
export const none = "#a6a6a6"

export const statSup10 = "#17b459";
export const statSup1 = "#add293";
export const statSupMinus5 = "#eba873";

export const proprio = "#17b459";
export const locat = "#add293";
export const hlmLoc = "#eba873";

export const mainWhite = "white";
export const titleTextColor = "#2509e9";
export const mainTextColor = "#000000";
export const secondTextColor = "#3222a5";
export const BubbleColor = "#3222a5";
export const thirdTextColor = "white";

export const backgroundColor = "#EFEFEF";

export const statSupMinus10 = "#e30c25";

export const defautMargin = "25px";
export const font = '"Montserrat", "DejaVu Sans", "Arial", sans-serif';

export const fontWidthThin = 200;
export const fontWidthMedium = 300;
export const fontWidthStrong = 400;
export const fontWidthVeryStrong = 700;
export const fontSizeVeryStrong = "1.8rem";
export const fontLineHeightVeryStrong = "2.2rem";

export const defaultMargin = "25px";


export default function App() {
    const queryParameters = new URLSearchParams(window.location.search)

    const commune = queryParameters.get("commune") !== null;
    if (commune) {
        return (
            <PageCommune/>
        );
    } else {
        return (<PageIris/>)
    }

}

